import React from "react";
import bg from "assests/Academy/Website-Banner-Product-2400x1000px-V1.jpg";
import Container from "Components/Container/Container";
import { Link } from "react-router-dom";
const Hero = () => {
  return (
    <section
      className="normal-section-80 pt-32 pb-12 lg:pt-0 lg:pb-0 w-full background-no-center"
      style={{
        backgroundImage: `url(${bg})`,
      }}
    >
      <Container className="h-full flex flex-col justify-center">
        <div>
          <h1 className="text- title">Academy</h1>
        </div>

        <div className="flex items-cenetr gap-x-2 text-font text-lg">
          <Link to={"/"} className="hover:underline">
            Home
          </Link>
          <span>|</span>
          <p>Academy</p>
          <span>|</span>
          <p>Training</p>
        </div>
      </Container>
    </section>
  );
};

export default Hero;
